<template>
  <div class="netbanner" :data-show="visible ? '' : null" role="status" aria-live="polite">
    <base-icon name="wifi-off" :width="2.2" />
    <span>اتصال اینترنت برقرار نیست</span>
  </div>
</template>

<script>
import BaseIcon from "./BaseIcon.vue";

/**
 * Slim ambient banner shown whenever the device reports no network.
 *
 * Always rendered and animated in and out rather than toggled with `v-if`, so it slides
 * rather than appearing abruptly — and so screen readers see a stable live region.
 */
export default {
  name: "OfflineBanner",
  components: { BaseIcon },

  props: {
    visible: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.netbanner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 46;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--warn);
  color: #fff;
  font-size: 12.5px;
  font-weight: 700;
  padding: 9px 14px;
  transform: translateY(-102%);
  transition: transform 0.32s cubic-bezier(0.32, 0.72, 0, 1);
  box-shadow: 0 10px 24px -14px rgba(0, 0, 0, 0.55);
}

.netbanner[data-show] {
  transform: none;
}

.netbanner >>> svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
}

@media (prefers-reduced-motion: reduce) {
  .netbanner {
    transition: none;
  }
}
</style>
